import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translations for the application
const resources = {
  en: {
    translation: {
      'Monitoring portal': 'Monitoring Portal',
      'for leakage detection': 'for Leakage Detection',
      Dashboard: 'Dashboard',
      Status: 'Status',
      'Alarm protocol': 'Alert log',
      Documents: 'Documents',
      Management: 'Management',
      Logout: 'Logout',
      'Latest Measurements:': 'Latest Measurements:',
      Snapshot: 'Snapshot',
      latest: 'latest',
      'Project Data:': 'Project Data:',
      // AlarmProtocol (v2)
      'alarm.col.timestamp': 'Time',
      'alarm.col.installation': 'Installation',
      'alarm.col.type': 'Type',
      'alarm.col.cabinet': 'Cabinet',
      'alarm.col.focusPoint': 'Focus point',
      'alarm.col.status': 'Status',
      'alarm.col.actions': 'Actions',
      'alarm.type.leakage': 'Leakage',
      'alarm.type.power': 'Power',
      'alarm.type.offline': 'Offline',
      'alarm.type.stale': 'Stale',
      'alarm.type.dead': 'Offline',
      'alarm.status.active': 'Active',
      'alarm.status.acknowledged': 'Acknowledged',
      'alarm.status.resolved': 'Resolved',
      'alarm.action.acknowledge': 'Acknowledge',
      'alarm.action.resolve': 'Resolve',
      'alarm.action.reopen': 'Reopen',
      'alarm.action.delete': 'Delete',
      'alarm.confirmDeleteTitle': 'Delete this alert?',
      'alarm.confirmDeleteMessage':
        'This will permanently remove the alert from the database. The action cannot be undone.',
      'manualAlert.toggleOn': 'Create alert',
      'manualAlert.toggleOff': 'Cancel',
      'manualAlert.instructions': 'Click on the visualization to place the focal point.',
      'manualAlert.formTitle': 'New manual alert',
      'manualAlert.focusPoint': 'Focal point',
      'manualAlert.type': 'Type',
      'manualAlert.severity': 'Severity',
      'manualAlert.message': 'Message (optional)',
      'manualAlert.submit': 'Create alert',
      'manualAlert.submitting': 'Creating…',
      'manualAlert.cancel': 'Cancel',
      'manualAlert.successToast': 'Alert created.',
      'manualAlert.errorToast': 'Could not create alert.',
      'manualAlert.severityCritical': 'Critical',
      'manualAlert.severityHigh': 'High',
      'manualAlert.severityMedium': 'Medium',
      'manualAlert.severityLow': 'Low',
      'profile.title': 'Change password',
      'profile.currentPassword': 'Current password',
      'profile.newPassword': 'New password',
      'profile.confirmPassword': 'Confirm new password',
      'profile.submit': 'Update password',
      'profile.submitting': 'Updating…',
      'profile.successToast': 'Password updated. Other sessions have been signed out.',
      'profile.errorGeneric': 'Could not change password.',
      'profile.errorTooShort': 'Must be at least {{min}} characters.',
      'profile.errorMismatch': 'Passwords do not match.',
      'alarm.filter.type': 'Type',
      'alarm.filter.status': 'Status',
      'alarm.noAlerts': 'No alerts match the current filters.',
      'alarm.noMeasurements': 'No measurement snapshot stored for this alert.',
      'Failed to load alerts': 'Failed to load alerts',
      'Failed to load installation structure': 'Failed to load installation structure',
      Name: 'Name',
      Address: 'Address',
      'Taken into operation': 'Taken into operation',
      Type: 'Type',
      'Monitored roof area': 'Monitored area',
      'System Status': 'System Status',
      'Leakage suspicion at coordinates:': 'High signal at coordinates:',
      'Condition OK at current measurement.': 'Condition OK at current measurement.',
      'Leakage Warnings': 'Leakage Warnings',
      'System Disruptions': 'System Disruptions',
      Date: 'Date',
      AlertDate: 'Alert generated',
      'X-Coordinate': 'X-Coordinate',
      'Y-Coordinate': 'Y-Coordinate',
      'Last recorded measurement': 'Last recorded measurement',
      Resolved: 'Resolved',
      Active: 'Active',
      Punkt: 'Point',
      'Leakage Warning:': 'Most recently recorded measurement for Leakage Warning:',
      Images: 'Images',
      Image: 'Image',
      User: 'User',
      // Management UI
      'management.title': 'Management',
      'management.companies': 'Companies',
      'management.projects': 'Projects',
      'management.installations': 'Installations',
      'management.users': 'Users',
      'management.create': 'Create',
      'management.edit': 'Edit',
      'management.delete': 'Delete',
      'management.save': 'Save',
      'management.cancel': 'Cancel',
      'management.actions': 'Actions',
      'management.expand': 'Expand',
      'management.collapse': 'Collapse',
      'management.noData': 'No entries found.',
      'management.saving': 'Saving...',
      'management.deleting': 'Deleting...',
      'management.accessDenied': 'Access denied. Admin privileges required.',
      'management.confirmDeleteTitle': 'Confirm Deletion',
      'management.confirmDeleteMessage':
        'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
      // Company fields
      'management.company.name': 'Company Name',
      'management.company.address': 'Address',
      'management.company.description': 'Description',
      'management.company.contactEmail': 'Contact Email',
      'management.company.contactPhone': 'Contact Phone',
      // Project fields
      'management.project.name': 'Project Name',
      'management.project.description': 'Description',
      'management.project.address': 'Address',
      'management.project.company': 'Company',
      'management.project.installations': 'Installations',
      'management.project.documents': 'Documents',
      'management.project.selectCompany': '-- Select Company --',
      'management.project.accessUsers': 'Users with access',
      'management.project.noAccessUsers': 'No users have access',
      'management.project.noInstallations': 'No installations in this project',
      'management.project.addNewInstallation': 'New installation',
      'management.project.attachExisting': 'Attach existing',
      'management.project.selectInstallation': '-- Select installation --',
      'management.project.removeFromProject': 'Remove from project',
      // Installation fields
      'management.installation.name': 'Installation Name',
      'management.installation.description': 'Description',
      'management.installation.company': 'Company',
      'management.installation.location': 'Location',
      'management.installation.address': 'Address',
      'management.installation.latitude': 'Latitude',
      'management.installation.longitude': 'Longitude',
      'management.installation.configuration': 'Configuration',
      'management.installation.leakageThreshold': 'Leakage Threshold',
      'management.installation.deadmanThreshold': 'Deadman Threshold',
      'management.installation.deadmanUnit': 'Deadman threshold unit',
      'management.installation.unitHours': 'hours',
      'management.installation.unitDays': 'days',
      'management.installation.metadata': 'Metadata',
      'management.installation.monitoredArea': 'Monitored Area (m\u00B2)',
      'management.installation.dateStartOperation': 'Start of Operation',
      'management.installation.measuringSystem': 'Measuring System',
      'management.installation.brand': 'Brand',
      'management.installation.latestMeasurement': 'Latest measurement',
      'management.alert.ok': 'OK',
      'management.alert.none': 'No open alerts',
      'management.alert.open': 'open',
      'management.alert.severity.critical': 'Critical',
      'management.alert.severity.high': 'High',
      'management.alert.severity.medium': 'Medium',
      'management.alert.severity.low': 'Low',
      'management.installation.siteImages': 'Site Images',
      'management.installation.pipelineConfig': 'Pipeline Configuration',
      'management.installation.gridStep': 'Grid Step (m)',
      'management.installation.analyticsHistoryDays': 'Analytics History (days)',
      'management.installation.influxInstallationName': 'InfluxDB Installation Name',
      'management.installation.influxInstallationNameHint': 'Same as installation name',
      'management.installation.defaultReferenceElectrode': 'Default Reference Electrode',
      'management.installation.voltageComboFilter': 'Voltage Combo Filter',
      'management.installation.colorScaleMin': 'Color Scale Min',
      'management.installation.colorScaleMax': 'Color Scale Max',
      'management.installation.colorScaleAutoHint': 'auto (p5/p95 of point values)',
      // User fields
      'management.user.name': 'Name',
      'management.user.email': 'Email',
      'management.user.password': 'Password',
      'management.user.passwordHint': 'Leave blank to keep current password',
      'management.user.isAdmin': 'Administrator',
      'management.user.projects': 'Project Access',
      'management.user.language': 'Preferred language',
      // Language
      'language.de': 'German',
      'language.en': 'English',
      'language.saveFailed': 'Could not save language preference',
      // Auth
      'auth.sessionExpired': 'Your session has expired. Please log in again.',
      // Alert banner
      'alert.asOf': 'as of {{time}}',
      'alert.countActive': '{{count}} active alert',
      'alert.countActive_other': '{{count}} active alerts',
      // Status view toggle
      'status.viewMode': 'View',
      'status.view.voltage': 'Voltage',
      'status.view.deviation': 'Deviation',
      // Per-cabinet status bar
      'status.cabinet': 'Cabinet {{nr}}',
      'status.cabinet.stale': 'STALE',
      'status.cabinet.age': '{{age}} ago',
      'status.cabinet.never': 'no data',
      'status.cabinet.installation': 'Installation',
      'dashboard.history.error': 'Measurement history could not be loaded.',
      'dashboard.history.carriedForward': 'no new data',
      'status.refresh': 'Refresh data',
      // Admin color-scale control
      'colorScale.edit': 'Color scale ({{mode}})',
      'colorScale.title': 'Color scale',
      'colorScale.min': 'Min',
      'colorScale.max': 'Max',
      'colorScale.preview': 'Preview',
      'colorScale.save': 'Save',
      'colorScale.auto': 'Auto',
      'colorScale.close': 'Close',
      'colorScale.invalid': 'Min must be less than max.',
      'colorScale.saved': 'Color scale saved.',
      'colorScale.reset': 'Color scale reset to automatic.',
      // Admin feature-visibility control
      'featureVis.title': 'Visualization settings',
      'featureVis.timeline': 'Timeline',
      'featureVis.deviation': 'Deviation view',
      'featureVis.mple': 'Electrode lines (MPLE)',
      'featureVis.interpolation': 'Interpolated color field',
      'featureVis.pointSize': 'Point size',
      'featureVis.saved': 'Settings updated.',
      // Visualization tooltip
      'viz.coordinates': 'Coordinates',
      'viz.resetZoom': 'Reset zoom',
      'viz.value': 'Value',
      'viz.mple': 'MPLE',
      'viz.karte': 'Card',
      'viz.abgriff': 'Tap',
      'viz.timestamp': 'Timestamp',
      // File management
      'management.files.upload': 'Upload File',
      'management.files.dragDrop': 'Drag & drop a file here, or click to browse',
      'management.files.noFiles': 'No files uploaded yet.',
      'management.files.saveFirst': 'Save the entity first to upload files.',
    },
  },
  de: {
    translation: {
      'Monitoring portal': 'Überwachungsportal',
      'for leakage detection': 'für Leckageerkennung',
      Dashboard: 'Dashboard',
      Status: 'Status',
      'Alarm protocol': 'Alarmprotokoll',
      Documents: 'Dokumente',
      Management: 'Verwaltung',
      Logout: 'Abmelden',
      'Latest Measurements:': 'Letzte Messungen:',
      Snapshot: 'Zeitpunkt',
      // AlarmProtocol (v2)
      'alarm.col.timestamp': 'Zeit',
      'alarm.col.installation': 'Installation',
      'alarm.col.type': 'Typ',
      'alarm.col.cabinet': 'Schaltschrank',
      'alarm.col.focusPoint': 'Fokuspunkt',
      'alarm.col.status': 'Status',
      'alarm.col.actions': 'Aktionen',
      'alarm.type.leakage': 'Leckage',
      'alarm.type.power': 'Stromausfall',
      'alarm.type.offline': 'Ausfall',
      'alarm.type.stale': 'Veraltet',
      'alarm.type.dead': 'Ausfall',
      'alarm.status.active': 'Aktiv',
      'alarm.status.acknowledged': 'Bestätigt',
      'alarm.status.resolved': 'Behoben',
      'alarm.action.acknowledge': 'Bestätigen',
      'alarm.action.resolve': 'Beheben',
      'alarm.action.reopen': 'Wiedereröffnen',
      'alarm.action.delete': 'Löschen',
      'alarm.confirmDeleteTitle': 'Diesen Alarm löschen?',
      'manualAlert.toggleOn': 'Alarm erstellen',
      'manualAlert.toggleOff': 'Abbrechen',
      'manualAlert.instructions': 'Klicken Sie in die Visualisierung, um den Fokuspunkt zu setzen.',
      'manualAlert.formTitle': 'Neuer manueller Alarm',
      'manualAlert.focusPoint': 'Fokuspunkt',
      'manualAlert.type': 'Typ',
      'manualAlert.severity': 'Schweregrad',
      'manualAlert.message': 'Nachricht (optional)',
      'manualAlert.submit': 'Alarm erstellen',
      'manualAlert.submitting': 'Wird erstellt…',
      'manualAlert.cancel': 'Abbrechen',
      'manualAlert.successToast': 'Alarm erstellt.',
      'manualAlert.errorToast': 'Alarm konnte nicht erstellt werden.',
      'manualAlert.severityCritical': 'Kritisch',
      'manualAlert.severityHigh': 'Hoch',
      'manualAlert.severityMedium': 'Mittel',
      'manualAlert.severityLow': 'Niedrig',
      'alarm.confirmDeleteMessage':
        'Der Alarm wird endgültig aus der Datenbank entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
      'profile.title': 'Passwort ändern',
      'profile.currentPassword': 'Aktuelles Passwort',
      'profile.newPassword': 'Neues Passwort',
      'profile.confirmPassword': 'Neues Passwort bestätigen',
      'profile.submit': 'Passwort aktualisieren',
      'profile.submitting': 'Wird aktualisiert…',
      'profile.successToast': 'Passwort wurde aktualisiert. Andere Sitzungen wurden abgemeldet.',
      'profile.errorGeneric': 'Passwort konnte nicht geändert werden.',
      'profile.errorTooShort': 'Mindestens {{min}} Zeichen erforderlich.',
      'profile.errorMismatch': 'Passwörter stimmen nicht überein.',
      'alarm.filter.type': 'Typ',
      'alarm.filter.status': 'Status',
      'alarm.noAlerts': 'Keine Alarme entsprechen den aktuellen Filtern.',
      'alarm.noMeasurements': 'Für diesen Alarm wurde kein Messungs-Snapshot gespeichert.',
      'Failed to load alerts': 'Alarme konnten nicht geladen werden',
      'Failed to load installation structure': 'Installationsstruktur konnte nicht geladen werden',
      latest: 'aktuell',
      'Project Data:': 'Projektdaten:',
      Project: 'Projekt',
      Projects: 'Projekte',
      Name: 'Name',
      Address: 'Adresse',
      'Taken into operation': 'In Betrieb genommen',
      Type: 'Typ',
      'Monitored roof area': 'Überwachte Fläche',
      'System Status': 'Systemstatus',
      'Leakage suspicion at coordinates:': 'Starkes Signal an Koordinaten:',
      'Condition OK at current measurement.': 'Zustand OK bei aktueller Messung.',
      'Leakage Warnings': 'Leckage Warnungen',
      'System Disruptions': 'System Störungen',
      Date: 'Datum',
      AlertDate: 'Alarm erstellt am',
      'X-Coordinate': 'X-Koordinate',
      'Y-Coordinate': 'Y-Koordinate',
      'Last recorded measurement': 'Letzte erfasste Messung',
      Resolved: 'Normalisiert',
      Active: 'Aktiv',
      Point: 'Punkt',
      'Leakage Warning:': 'Aktuellste Messung der Leckage Warnung:',
      Images: 'Bilder',
      Image: 'Bild',
      User: 'Nutzer',
      // Management UI
      'management.title': 'Verwaltung',
      'management.companies': 'Unternehmen',
      'management.projects': 'Projekte',
      'management.installations': 'Installationen',
      'management.users': 'Nutzer',
      'management.create': 'Erstellen',
      'management.edit': 'Bearbeiten',
      'management.delete': 'L\u00F6schen',
      'management.save': 'Speichern',
      'management.cancel': 'Abbrechen',
      'management.actions': 'Aktionen',
      'management.expand': 'Aufklappen',
      'management.collapse': 'Zuklappen',
      'management.noData': 'Keine Eintr\u00E4ge gefunden.',
      'management.saving': 'Speichern...',
      'management.deleting': 'L\u00F6schen...',
      'management.accessDenied': 'Zugriff verweigert. Administratorrechte erforderlich.',
      'management.confirmDeleteTitle': 'L\u00F6schung best\u00E4tigen',
      'management.confirmDeleteMessage':
        'Sind Sie sicher, dass Sie "{{name}}" l\u00F6schen m\u00F6chten? Diese Aktion kann nicht r\u00FCckg\u00E4ngig gemacht werden.',
      // Company fields
      'management.company.name': 'Firmenname',
      'management.company.address': 'Adresse',
      'management.company.description': 'Beschreibung',
      'management.company.contactEmail': 'Kontakt-E-Mail',
      'management.company.contactPhone': 'Kontakttelefon',
      // Project fields
      'management.project.name': 'Projektname',
      'management.project.description': 'Beschreibung',
      'management.project.address': 'Adresse',
      'management.project.company': 'Unternehmen',
      'management.project.installations': 'Installationen',
      'management.project.documents': 'Dokumente',
      'management.project.selectCompany': '-- Unternehmen w\u00E4hlen --',
      'management.project.accessUsers': 'Benutzer mit Zugriff',
      'management.project.noAccessUsers': 'Keine Benutzer mit Zugriff',
      'management.project.noInstallations': 'Keine Installationen in diesem Projekt',
      'management.project.addNewInstallation': 'Neue Installation',
      'management.project.attachExisting': 'Bestehende zuordnen',
      'management.project.selectInstallation': '-- Installation w\u00E4hlen --',
      'management.project.removeFromProject': 'Aus Projekt entfernen',
      // Installation fields
      'management.installation.name': 'Installationsname',
      'management.installation.description': 'Beschreibung',
      'management.installation.company': 'Unternehmen',
      'management.installation.location': 'Standort',
      'management.installation.address': 'Adresse',
      'management.installation.latitude': 'Breitengrad',
      'management.installation.longitude': 'L\u00E4ngengrad',
      'management.installation.configuration': 'Konfiguration',
      'management.installation.leakageThreshold': 'Leckage-Schwellenwert',
      'management.installation.deadmanThreshold': 'Deadman-Schwellenwert',
      'management.installation.deadmanUnit': 'Einheit Deadman-Schwellenwert',
      'management.installation.unitHours': 'Stunden',
      'management.installation.unitDays': 'Tage',
      'management.installation.metadata': 'Metadaten',
      'management.installation.monitoredArea': '\u00DCberwachte Fl\u00E4che (m\u00B2)',
      'management.installation.dateStartOperation': 'Betriebsbeginn',
      'management.installation.measuringSystem': 'Messsystem',
      'management.installation.brand': 'Marke',
      'management.installation.latestMeasurement': 'Letzte Messung',
      'management.alert.ok': 'OK',
      'management.alert.none': 'Keine offenen Alarme',
      'management.alert.open': 'offen',
      'management.alert.severity.critical': 'Kritisch',
      'management.alert.severity.high': 'Hoch',
      'management.alert.severity.medium': 'Mittel',
      'management.alert.severity.low': 'Niedrig',
      'management.installation.siteImages': 'Standortbilder',
      'management.installation.pipelineConfig': 'Pipeline-Konfiguration',
      'management.installation.gridStep': 'Rasterschritt (m)',
      'management.installation.analyticsHistoryDays': 'Analyse-Historie (Tage)',
      'management.installation.influxInstallationName': 'InfluxDB-Installationsname',
      'management.installation.influxInstallationNameHint': 'Wie Installationsname',
      'management.installation.defaultReferenceElectrode': 'Standard-Referenzelektrode',
      'management.installation.voltageComboFilter': 'Spannungskombi-Filter',
      'management.installation.colorScaleMin': 'Farbskala Min',
      'management.installation.colorScaleMax': 'Farbskala Max',
      'management.installation.colorScaleAutoHint': 'auto (p5/p95 der Messwerte)',
      // User fields
      'management.user.name': 'Name',
      'management.user.email': 'E-Mail',
      'management.user.password': 'Passwort',
      'management.user.passwordHint': 'Leer lassen, um aktuelles Passwort beizubehalten',
      'management.user.isAdmin': 'Administrator',
      'management.user.projects': 'Projektzugang',
      'management.user.language': 'Bevorzugte Sprache',
      // Language
      'language.de': 'Deutsch',
      'language.en': 'Englisch',
      'language.saveFailed': 'Sprachpräferenz konnte nicht gespeichert werden',
      // Auth
      'auth.sessionExpired': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      // Alert banner
      'alert.asOf': 'Stand {{time}}',
      'alert.countActive': '{{count}} aktiver Alarm',
      'alert.countActive_other': '{{count}} aktive Alarme',
      // Status view toggle
      'status.viewMode': 'Ansicht',
      'status.view.voltage': 'Spannung',
      'status.view.deviation': 'Abweichung',
      // Per-cabinet status bar
      'status.cabinet': 'Schrank {{nr}}',
      'status.cabinet.stale': 'VERALTET',
      'status.cabinet.age': 'vor {{age}}',
      'status.cabinet.never': 'keine Daten',
      'status.cabinet.installation': 'Anlage',
      'dashboard.history.error': 'Messverlauf konnte nicht geladen werden.',
      'dashboard.history.carriedForward': 'keine neuen Daten',
      'status.refresh': 'Daten aktualisieren',
      // Admin color-scale control
      'colorScale.edit': 'Farbskala ({{mode}})',
      'colorScale.title': 'Farbskala',
      'colorScale.min': 'Min',
      'colorScale.max': 'Max',
      'colorScale.preview': 'Vorschau',
      'colorScale.save': 'Speichern',
      'colorScale.auto': 'Auto',
      'colorScale.close': 'Schließen',
      'colorScale.invalid': 'Min muss kleiner als Max sein.',
      'colorScale.saved': 'Farbskala gespeichert.',
      'colorScale.reset': 'Farbskala auf automatisch zurückgesetzt.',
      // Admin feature-visibility control
      'featureVis.title': 'Visualisierungseinstellungen',
      'featureVis.timeline': 'Zeitverlauf',
      'featureVis.deviation': 'Abweichungsansicht',
      'featureVis.mple': 'Elektrodenlinien (MPLE)',
      'featureVis.interpolation': 'Interpoliertes Farbfeld',
      'featureVis.pointSize': 'Punktgröße',
      'featureVis.saved': 'Einstellungen aktualisiert.',
      // Visualization tooltip
      'viz.coordinates': 'Koordinaten',
      'viz.resetZoom': 'Zoom zurücksetzen',
      'viz.value': 'Messwert',
      'viz.mple': 'MPLE',
      'viz.karte': 'Karte',
      'viz.abgriff': 'Abgriff',
      'viz.timestamp': 'Zeitpunkt',
      // File management
      'management.files.upload': 'Datei hochladen',
      'management.files.dragDrop': 'Datei hierher ziehen oder klicken zum Durchsuchen',
      'management.files.noFiles': 'Noch keine Dateien hochgeladen.',
      'management.files.saveFirst': 'Speichern Sie zuerst, um Dateien hochzuladen.',
    },
  },
};

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .use(LanguageDetector) // Detects user language
  .init({
    resources,
    fallbackLng: 'en', // Use English if detection fails
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
  });

export default i18n;
